import { createFileRoute } from '@tanstack/react-router'

import { AnalysisDetail } from '@/pages/Lens/AnalysisDetail'

export const Route = createFileRoute('/_app/lens/$analysisId/')({
  component: AnalysisDetailRoute,
})

function AnalysisDetailRoute() {
  const { analysisId } = Route.useParams()
  return <AnalysisDetail analysisId={analysisId} />
}
